//Core
import React from "react"

//Styles
import style from "./style.module.scss"

//Helpers
import { classes } from "../../../helpers/classname"

const { Container, Button, Title, bottomSpace } = style

const RulesButton = ({
  link,
  background,
  bottom = true,
  title = "Пропозиція діє з 01 cічня 2020 по 31 cічня 2020",
}) => {
  return (
    <div
      className={classes(Container, bottom ? bottomSpace : "")}
      style={{ backgroundColor: background }}
    >
      <h2 className={Title}>{title}</h2>
      <a href={link} target="_blank" rel="noopener noreferrer">
        <div className={Button}>Офіційні правила акції</div>
      </a>
    </div>
  )
}

export default RulesButton
